export type PromoCodeErrorResponse = {
  error_code: string;
  error_message: string;
  timestamp: string;
};

export class PromoCodeError extends Error {
  errorCode?: string;
  errorKey: string;
  timeStamp?: string;

  constructor(message: string, errorKey: string, errorCode?: string, timeStamp?: string) {
    super(message);
    this.name = 'PromoCodeError';
    this.errorCode = errorCode;
    this.errorKey = errorKey;
    this.timeStamp = timeStamp;
  }
}
